import { ITab } from './PdfEnhancementPanel/TabBar/TabBar';

export const FORMATTING = 'Formatting';
export const PDF_STYLING = 'PDF Styling';
export const ACCESSIBILITY_CHECKER = 'Accessibility Checker';

export const FormattingTab: ITab = { path: '', name: FORMATTING };
export const PdfStylingTab: ITab = { path: 'pdf-styling', name: PDF_STYLING };
export const AccessibilityCheckerTab: ITab = { path: 'accessibility-checker', name: ACCESSIBILITY_CHECKER };
export const TABS_PDF_ENHANCEMENT = [FormattingTab, PdfStylingTab, AccessibilityCheckerTab];
